import React from "react";
import InputField from "components/InputField/InputField";
import SelectField from "components/InputField/SelectField";
import PropTypes from "prop-types";

const labels = {
  first_name: "First name",
  last_name: "Last name",
  email: "Email",
  password: "Password",
  company_name: "Company",
  host_group_ids: "MedMeetings",
};

const EditSuperhostForm = ({
  superhost: { first_name, last_name, host_group_ids, email },
  studyGroups,
  onFieldChange,
  onSubmit,
  errors = {},
}) => {
  return (
    <div className="container_records">
      <div className="add_webinar add_superhost">
        <h3>Edit Superhost</h3>
        <div className="add_webinar_bg row">
          <form className="col s12">
            <div className="row">
              {[
                {
                  field_name: "first_name",
                  value: first_name,
                },
                {
                  field_name: "last_name",
                  value: last_name,
                },
              ].map((e) => (
                <InputField
                  className="col s12 m6"
                  label={labels[e.field_name]}
                  onChange={onFieldChange}
                  errors={errors[e.field_name]}
                  {...e}
                />
              ))}
              <InputField
                className="col s12 m6"
                label={labels["email"]}
                onChange={onFieldChange}
                errors={errors["email"]}
                value={email}
              />

              <SelectField
                className="col s12 form-control-select"
                label={labels["host_group_ids"]}
                onChange={onFieldChange}
                errors={errors["host_group_ids"]}
                field_name="host_group_ids"
                value={host_group_ids}
                options={studyGroups}
                multiple
              />
              <div className="submit_center col s12">
                <button
                  onClick={onSubmit}
                  className="button_classic"
                  type="button"
                  name="button"
                >
                  Edit
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
EditSuperhostForm.defaultProps = {};

EditSuperhostForm.propTypes = {
  superhost: PropTypes.object,
  onFieldChange: PropTypes.func,
  onSubmit: PropTypes.func,
  errors: PropTypes.array,
};

export default EditSuperhostForm;



// WEBPACK FOOTER //
// ./src/components/Admin/Superhosts/EditSuperhostForm.jsx